import RankingsPage from './RankingsPage';
import VoteNotification from './VoteNotification';
import VotesModal from './VotesModal';

export const components = {
    RankingsPage,
    VoteNotification,
    VotesModal,
};
